import React from "react";
import {
    ListItem,
    ListItemText,
    List,
    ListItemAvatar,
    Avatar,
    Collapse,
    Icon,
    styled,
} from '@mui/material';
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { Link } from 'react-router-dom';
import { scrollToTop } from "../../common/extensions";

const PREFIX = 'MenuItem';

const classes = {
    root: `${PREFIX}-root`,
    nested: `${PREFIX}-nested`,
    expandCollapseIcon: `${PREFIX}-expandCollapseIcon`,
    listItemText: `${PREFIX}-listItemText`,
    listItemAvatar: `${PREFIX}-listItemAvatar`,
    avatar: `${PREFIX}-avatar`,
    icon: `${PREFIX}-icon`,
    customMenuItem: `${PREFIX}-customMenuItem`
};

const Root = styled('span')((
    {
        theme
    }
) => ({
    [`& .${classes.root}`]: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },

    [`& .${classes.nested}`]: {
        paddingLeft: theme.spacing(4),
        backgroundColor: theme.palette.primary.light,
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: theme.palette.primary.main
    },

    [`& .${classes.expandCollapseIcon}`]: {
        color: theme.palette.common.white
    },

    [`& .${classes.listItemText}`]: {
        color: theme.palette.common.white
    },

    [`& .${classes.listItemAvatar}`]: {
        height: 25,
        minWidth: 35
    },

    [`& .${classes.avatar}`]: {
        backgroundColor: theme.palette.primary.main,
        height: 30,
        width: 30
    },

    [`& .${classes.icon}`]: {
        color: theme.palette.common.white
    },

    [`& .${classes.customMenuItem}`]: {
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: theme.palette.primary.light
    }
}));

const MenuItem = (props) => {

    const [open, setOpen] = React.useState(true);

    const handleClick = (e) => {
        e.preventDefault();
        setOpen(!open);
    };

    const handleLinkClick = (e, to) => {
        if (to)
            scrollToTop();
        else
            e.preventDefault();
    }

    return (
        <Root>
            <ListItem button onClick={e => props.menuItem.to ? handleLinkClick(e, props.menuItem.to) : handleClick(e)} component={Link} to={props.menuItem.to} title={props.menuItem.title} className={classes.customMenuItem}>
                <ListItemAvatar className={classes.listItemAvatar}>
                    {props.menuItem.icon ? <Icon className={classes.icon}>{props.menuItem.icon}</Icon> :
                        <Avatar className={classes.avatar}>{props.menuItem.title.substring(0, 1)}</Avatar>}
                </ListItemAvatar>
                <ListItemText primary={props.menuItem.title} className={classes.listItemText} />
                {props.menuItem.subItems && (open ? <ExpandLess className={classes.expandCollapseIcon} /> : <ExpandMore className={classes.expandCollapseIcon} />)}
            </ListItem>
            {props.menuItem.subItems &&
                <React.Fragment>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {props.menuItem.subItems.map((menuItem, index) => (
                                <React.Fragment key={index}>
                                    <ListItem button onClick={e => handleLinkClick(e, menuItem.to)} className={classes.nested} component={Link} to={menuItem.to} title={menuItem.title}>
                                        <ListItemAvatar className={classes.listItemAvatar}>{menuItem.icon ? <Icon className={classes.icon}>{menuItem.icon}</Icon> :
                                            <Avatar className={classes.avatar}>{menuItem.title.substring(0, 1)}</Avatar>}
                                        </ListItemAvatar>
                                        <ListItemText primary={menuItem.title} className={classes.listItemText} />
                                    </ListItem>
                                </React.Fragment>
                            ))}
                        </List>
                    </Collapse>
                </React.Fragment>}
        </Root>
    );
}

export default MenuItem;